export enum OrderStatus {
    Unknown,
    Processed,
    Filled,
    Cancelled
  }
  